import styled from "styled-components";

export const CreatePage = styled.div`
    background-color: #ffffff;
    padding: 20px;
`;
